/**
 * MySpace – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

export default function MySpaceIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width || 24 * Screen.widthRatio}`}
      height={`${height || 25 * Screen.widthRatio}`}
      style={{ marginTop: `${10 * Screen.widthRatio}px` }}
      viewBox={'0 0 23 25'}
      fill='none'
    >
      <path
        d='M11.1515 24.5791C10.3509 24.5791 9.53884 24.2703 8.93265 23.6641L6.97682 21.7312C6.49645 21.2508 5.83311 20.9877 5.1583 20.9877H4.28905C1.92149 20.9877 0 19.0777 0 16.733V4.2547C0 1.91002 1.92149 0 4.28905 0H18.014C20.3815 0 22.303 1.91002 22.303 4.2547V16.733C22.303 19.0777 20.3815 20.9877 18.014 20.9877H17.1447C16.4699 20.9877 15.8066 21.2622 15.3262 21.7312L13.3704 23.6641C12.7642 24.2703 11.9521 24.5791 11.1515 24.5791ZM4.28905 1.70417C2.8708 1.70417 1.71562 2.84788 1.71562 4.24325V16.7216C1.71562 18.1284 2.8708 19.2606 4.28905 19.2606H5.1583C6.29061 19.2606 7.38857 19.7182 8.18919 20.5074L10.145 22.4403C10.7055 22.9893 11.609 22.9893 12.1695 22.4403L14.1252 20.5074C14.9259 19.7182 16.0239 19.2606 17.1562 19.2606H18.014C19.4322 19.2606 20.5874 18.1169 20.5874 16.7216V4.24325C20.5874 2.83644 19.4322 1.70417 18.014 1.70417H4.28905Z'
        fill={color}
      />
      <path
        d='M11.1514 10.8542C9.20705 10.8542 7.62866 9.27583 7.62866 7.33146C7.62866 5.3871 9.20705 3.80878 11.1514 3.80878C13.0958 3.80878 14.6742 5.3871 14.6742 7.33146C14.6742 9.27583 13.0958 10.8542 11.1514 10.8542ZM11.1514 5.5244C10.1564 5.5244 9.34428 6.3364 9.34428 7.33146C9.34428 8.32652 10.1564 9.1386 11.1514 9.1386C12.1465 9.1386 12.9586 8.32652 12.9586 7.33146C12.9586 6.3364 12.1465 5.5244 11.1514 5.5244Z'
        fill={color}
      />
      <path
        d='M15.7265 17.3278C15.2576 17.3278 14.8687 16.939 14.8687 16.47C14.8687 14.8917 13.1988 13.5993 11.1515 13.5993C9.10424 13.5993 7.43437 14.8917 7.43437 16.47C7.43437 16.939 7.0455 17.3278 6.57656 17.3278C6.10762 17.3278 5.71875 16.939 5.71875 16.47C5.71875 13.9424 8.15493 11.8837 11.1515 11.8837C14.1482 11.8837 16.5843 13.9424 16.5843 16.47C16.5843 16.939 16.1955 17.3278 15.7265 17.3278Z'
        fill={color}
      />
    </svg>
  );
}
